import { forwardRef, HTMLAttributes, MouseEvent } from 'react';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';

import { link } from '@phoenix/core/frontend/shared/util/navigation/link.utils';

export interface LinkWrapperProps extends HTMLAttributes<HTMLAnchorElement> {
  onClick?: (e: MouseEvent<HTMLElement>) => void;
  routePath?: string;
  className?: string;
  hyperLink?: string;
  allowReferrer?: boolean;
  dataTestId?: string;
}

export const DynamicLinkWrapper = forwardRef<HTMLAnchorElement, LinkWrapperProps>(
  ({ routePath, hyperLink, children, allowReferrer = false, dataTestId, ...props }, ref) => {
    const { t } = useTranslation('shared');
    const commonProps = { ref, 'data-testid': dataTestId, ...props };

    if (!hyperLink && !routePath) {
      return <span {...commonProps}>{children}</span>;
    }

    return routePath ? (
      <Link href={link(routePath)} legacyBehavior>
        <a {...commonProps}>{children}</a>
      </Link>
    ) : (
      <a href={hyperLink} target="_blank" rel={allowReferrer ? undefined : 'noreferrer'} {...commonProps}>
        {children}
        <span className="sr-only">({t('shared_a11y_hint_opensInNewTab')})</span>
      </a>
    );
  }
);
